export enum VatCategoryType {
  t0 = 1,
  t1,
  t2,
}
